type Nullable<T> = T | null | undefined;

export const ensure: <T>(value: Nullable<T>, errorMessage?: string) => asserts value is T = <T>(
    value: Nullable<T>,
    errorMessage?: string
): asserts value is T => {
    if (value === undefined || value === null) {
        throw Error(errorMessage ?? "Value is missing.");
    }
};

export const ensureNotEmpty: <T>(value: Nullable<T>, errorMessage?: string) => asserts value is T = <T>(
    value: Nullable<T>,
    errorMessage?: string
): asserts value is T => {
    ensure(value);

    if ((typeof value === "string" && value === "") || (Array.isArray(value) && value.length === 0)) {
        throw Error(errorMessage ?? "Value is missing.");
    }
};
